import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { isDefined } from '@trimble-gcs/common';
import { filter, switchMap, take } from 'rxjs';
import { AppState } from '../app-state/app.state';
import { GET_CONNECT_REGION_URL } from '../connect/get-connect-region-url';
import { UserGroup } from './user-group.models';

@Injectable({
  providedIn: 'root',
})
export class UserGroupService {
  private readonly store = inject(Store);
  private readonly getConnectRegionUrl$ = inject(GET_CONNECT_REGION_URL);

  constructor(private http: HttpClient) {}

  getUserGroups() {
    return this.store.select(AppState.project).pipe(
      filter(isDefined),
      take(1),
      switchMap((connectProject) =>
        this.getConnectRegionUrl$(`/groups?projectId=${connectProject.id}`),
      ),
      switchMap((url) => this.http.get<UserGroup[]>(url)),
    );
  }
}
